import Modal from 'components/elements/Modal'

import { useActionless, useAppSelector } from 'app-redux/hooks'
import { TOGGLE_MODAL } from 'app-redux/active/actions/types'

import NewSnapshotForm from './newSnapshotForm'

const NewSnapshotModalStandalone = () => {
  const createSnapshotStandalone = useAppSelector(state => state.active.modals.createSnapshotStandalone)

  const [toggleModal] = useActionless(TOGGLE_MODAL)

  const handleCloseModal = () => toggleModal({ modalName: 'createSnapshotStandalone', flag: false })

  return (
    <Modal open={createSnapshotStandalone} onClose={handleCloseModal} closeButton>
      <h4>Create snapshot</h4>

      <NewSnapshotForm onCancel={handleCloseModal} onCreated={handleCloseModal} />
    </Modal>
  )
}

export default NewSnapshotModalStandalone
